// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * Overrides específicos para forçar cores ICAVI
 * Portal ICAVI
 */

/* Forçar cores ICAVI em todos os selects */
select:focus {
  border-color: var(--color-icavi-600) !important;
  box-shadow: 0 0 0 1px var(--color-icavi-600) !important;
  outline: none !important;
}

/* Forçar cores ICAVI em elementos option quando selecionados */
select option:checked {
  background: var(--color-icavi-600) !important;
  background-color: var(--color-icavi-600) !important;
  color: white !important;
}

/* Forçar remoção de cores azuis */
select option:checked {
  background: linear-gradient(
    0deg,
    var(--color-icavi-600) 0%,
    var(--color-icavi-600) 100%
  ) !important;
}

/* Forçar cores ICAVI em elementos option quando em hover - TEXTO LARANJA */
select option:hover {
  background: #ffe4d6 !important;
  background-color: #ffe4d6 !important;
  background-image: none !important;
  color: var(--color-icavi-600) !important;
}

/* Forçar cores ICAVI em elementos option quando em focus - TEXTO LARANJA */
select option:focus {
  background: #ffe4d6 !important;
  background-color: #ffe4d6 !important;
  background-image: none !important;
  color: var(--color-icavi-600) !important;
}

/* Forçar cores ICAVI em elementos option quando ativos - TEXTO LARANJA */
select option:active {
  background: #ffe4d6 !important;
  background-color: #ffe4d6 !important;
  background-image: none !important;
  color: var(--color-icavi-600) !important;
}

/* Forçar cores ICAVI em inputs quando em foco.
   \`data-foco-proprio\`: o componente desenha o próprio foco (ex.: composer do ICAVI AI, foco na caixa inteira). */
input:focus:not([data-foco-proprio]) {
  border-color: var(--color-icavi-600) !important;
  box-shadow: 0 0 0 1px var(--color-icavi-600) !important;
  outline: none !important;
}

/* Forçar cores ICAVI em textareas quando em foco */
textarea:focus:not([data-foco-proprio]) {
  border-color: var(--color-icavi-600) !important;
  box-shadow: 0 0 0 1px var(--color-icavi-600) !important;
  outline: none !important;
}

/* Override para elementos com classes Tailwind específicas */
.focus\\:ring-icavi-orange:focus {
  --tw-ring-color: var(--color-icavi-600) !important;
  box-shadow: 0 0 0 1px var(--color-icavi-600) !important;
}

.focus\\:border-icavi-orange:focus {
  border-color: var(--color-icavi-600) !important;
}

/* Forçar cores ICAVI em elementos com ring */
[class*='focus:ring-icavi']:focus {
  box-shadow: 0 0 0 1px var(--color-icavi-600) !important;
}

/* Forçar cores ICAVI em elementos com border */
[class*='focus:border-icavi']:focus {
  border-color: var(--color-icavi-600) !important;
}

/* Override específico para elementos select com classes Tailwind */
select.focus\\:ring-icavi-orange:focus,
select.focus\\:border-icavi-orange:focus {
  border-color: var(--color-icavi-600) !important;
  box-shadow: 0 0 0 1px var(--color-icavi-600) !important;
  outline: none !important;
}

/* Override para elementos input com classes Tailwind */
input.focus\\:ring-icavi-orange:focus,
input.focus\\:border-icavi-orange:focus {
  border-color: var(--color-icavi-600) !important;
  box-shadow: 0 0 0 1px var(--color-icavi-600) !important;
  outline: none !important;
}

/* Override para elementos textarea com classes Tailwind */
textarea.focus\\:ring-icavi-orange:focus,
textarea.focus\\:border-icavi-orange:focus {
  border-color: var(--color-icavi-600) !important;
  box-shadow: 0 0 0 1px var(--color-icavi-600) !important;
  outline: none !important;
}

/* Estilos específicos para hover em elementos select */
select:hover {
  border-color: var(--color-icavi-600) !important;
}

/* Forçar cores ICAVI em todos os estados de option */
select option {
  background: white !important;
  background-color: white !important;
  color: black !important;
}

/* Estados de interação - hover, focus, active - TEXTO LARANJA */
select option:hover,
select option:focus,
select option:active {
  background: #ffe4d6 !important;
  background-color: #ffe4d6 !important;
  background-image: none !important;
  color: var(--color-icavi-600) !important;
}

/* Estados selecionados - fundo laranja, texto branco */
select option:checked,
select option[selected] {
  background: var(--color-icavi-600) !important;
  background-color: var(--color-icavi-600) !important;
  background-image: none !important;
  color: white !important;
}

/* Forçar para elementos que têm a propriedade selected */
select option[selected='selected'],
select option[selected='true'] {
  background: var(--color-icavi-600) !important;
  background-color: var(--color-icavi-600) !important;
  color: white !important;
}

/* Estilos específicos para navegadores WebKit (Chrome, Safari, Edge) */
select option::-webkit-option {
  background-color: white !important;
  color: black !important;
}

select option:hover::-webkit-option,
select option:focus::-webkit-option,
select option:active::-webkit-option {
  background-color: #ffe4d6 !important;
  color: var(--color-icavi-600) !important;
}

select option:checked::-webkit-option,
select option[selected]::-webkit-option {
  background-color: var(--color-icavi-600) !important;
  color: white !important;
}

/* Estilos específicos para Firefox */
select option:-moz-any() {
  background-color: white !important;
  color: black !important;
}

select option:hover:-moz-any(),
select option:focus:-moz-any(),
select option:active:-moz-any() {
  background-color: #ffe4d6 !important;
  color: var(--color-icavi-600) !important;
}

select option:checked:-moz-any(),
select option[selected]:-moz-any() {
  background-color: var(--color-icavi-600) !important;
  color: white !important;
}

/* Remover especificamente cores azuis do Windows */
@supports (-ms-ime-align: auto) {
  select option:checked {
    background: var(--color-icavi-600) !important;
    background-color: var(--color-icavi-600) !important;
    background-image: none !important;
    color: white !important;
  }
  select option:hover {
    background: #ffe4d6 !important;
    background-color: #ffe4d6 !important;
    background-image: none !important;
    color: var(--color-icavi-600) !important;
  }
  select option:focus {
    background: #ffe4d6 !important;
    background-color: #ffe4d6 !important;
    background-image: none !important;
    color: var(--color-icavi-600) !important;
  }
  select option:active {
    background: #ffe4d6 !important;
    background-color: #ffe4d6 !important;
    background-image: none !important;
    color: var(--color-icavi-600) !important;
  }
}

/* Remover cores azuis em navegadores modernos */
select option::selection {
  background: var(--color-icavi-600) !important;
  color: white !important;
}

select option::-moz-selection {
  background: var(--color-icavi-600) !important;
  color: white !important;
}

/* Garantir que nenhum azul apareça */
select option {
  accent-color: var(--color-icavi-600) !important;
}

select {
  accent-color: var(--color-icavi-600) !important;
}
`, "",{"version":3,"sources":["webpack://./src/styles/icavi-overrides.css"],"names":[],"mappings":"AAAA;;;EAGE;;AAEF,2CAA2C;AAC3C;EACE,+CAA+C;EAC/C,uDAAuD;EACvD,wBAAwB;AAC1B;;AAEA,+DAA+D;AAC/D;EACE,6CAA6C;EAC7C,mDAAmD;EACnD,uBAAuB;AACzB;;AAEA,kCAAkC;AAClC;EACE;;;;cAIY;AACd;;AAEA,2EAA2E;AAC3E;EACE,8BAA8B;EAC9B,oCAAoC;EACpC,iCAAiC;EACjC,wCAAwC;AAC1C;;AAEA,2EAA2E;AAC3E;EACE,8BAA8B;EAC9B,oCAAoC;EACpC,iCAAiC;EACjC,wCAAwC;AAC1C;;AAEA,yEAAyE;AACzE;EACE,8BAA8B;EAC9B,oCAAoC;EACpC,iCAAiC;EACjC,wCAAwC;AAC1C;;AAEA;iHACiH;AACjH;EACE,+CAA+C;EAC/C,uDAAuD;EACvD,wBAAwB;AAC1B;;AAEA,mDAAmD;AACnD;EACE,+CAA+C;EAC/C,uDAAuD;EACvD,wBAAwB;AAC1B;;AAEA,6DAA6D;AAC7D;EACE,kDAAkD;EAClD,uDAAuD;AACzD;;AAEA;EACE,+CAA+C;AACjD;;AAEA,6CAA6C;AAC7C;EACE,uDAAuD;AACzD;;AAEA,+CAA+C;AAC/C;EACE,+CAA+C;AACjD;;AAEA,mEAAmE;AACnE;;EAEE,+CAA+C;EAC/C,uDAAuD;EACvD,wBAAwB;AAC1B;;AAEA,uDAAuD;AACvD;;EAEE,+CAA+C;EAC/C,uDAAuD;EACvD,wBAAwB;AAC1B;;AAEA,0DAA0D;AAC1D;;EAEE,+CAA+C;EAC/C,uDAAuD;EACvD,wBAAwB;AAC1B;;AAEA,uDAAuD;AACvD;EACE,+CAA+C;AACjD;;AAEA,qDAAqD;AACrD;EACE,4BAA4B;EAC5B,kCAAkC;EAClC,uBAAuB;AACzB;;AAEA,gEAAgE;AAChE;;;EAGE,8BAA8B;EAC9B,oCAAoC;EACpC,iCAAiC;EACjC,wCAAwC;AAC1C;;AAEA,uDAAuD;AACvD;;EAEE,6CAA6C;EAC7C,mDAAmD;EACnD,iCAAiC;EACjC,uBAAuB;AACzB;;AAEA,yDAAyD;AACzD;;EAEE,6CAA6C;EAC7C,mDAAmD;EACnD,uBAAuB;AACzB;;AAEA,uEAAuE;AACvE;EACE,kCAAkC;EAClC,uBAAuB;AACzB;;AAEA;;;EAGE,oCAAoC;EACpC,wCAAwC;AAC1C;;AAEA;;EAEE,mDAAmD;EACnD,uBAAuB;AACzB;;AAEA,qCAAqC;AACrC;EACE,kCAAkC;EAClC,uBAAuB;AACzB;;AAEA;;;EAGE,oCAAoC;EACpC,wCAAwC;AAC1C;;AAEA;;EAEE,mDAAmD;EACnD,uBAAuB;AACzB;;AAEA,mDAAmD;AACnD;EACE;IACE,6CAA6C;IAC7C,mDAAmD;IACnD,iCAAiC;IACjC,uBAAuB;EACzB;EACA;IACE,8BAA8B;IAC9B,oCAAoC;IACpC,iCAAiC;IACjC,wCAAwC;EAC1C;EACA;IACE,8BAA8B;IAC9B,oCAAoC;IACpC,iCAAiC;IACjC,wCAAwC;EAC1C;EACA;IACE,8BAA8B;IAC9B,oCAAoC;IACpC,iCAAiC;IACjC,wCAAwC;EAC1C;AACF;;AAEA,gDAAgD;AAChD;EACE,6CAA6C;EAC7C,uBAAuB;AACzB;;AAEA;EACE,6CAA6C;EAC7C,uBAAuB;AACzB;;AAEA,qCAAqC;AACrC;EACE,+CAA+C;AACjD;;AAEA;EACE,+CAA+C;AACjD","sourcesContent":["/**\n * Overrides específicos para forçar cores ICAVI\n * Portal ICAVI\n */\n\n/* Forçar cores ICAVI em todos os selects */\nselect:focus {\n  border-color: var(--color-icavi-600) !important;\n  box-shadow: 0 0 0 1px var(--color-icavi-600) !important;\n  outline: none !important;\n}\n\n/* Forçar cores ICAVI em elementos option quando selecionados */\nselect option:checked {\n  background: var(--color-icavi-600) !important;\n  background-color: var(--color-icavi-600) !important;\n  color: white !important;\n}\n\n/* Forçar remoção de cores azuis */\nselect option:checked {\n  background: linear-gradient(\n    0deg,\n    var(--color-icavi-600) 0%,\n    var(--color-icavi-600) 100%\n  ) !important;\n}\n\n/* Forçar cores ICAVI em elementos option quando em hover - TEXTO LARANJA */\nselect option:hover {\n  background: #ffe4d6 !important;\n  background-color: #ffe4d6 !important;\n  background-image: none !important;\n  color: var(--color-icavi-600) !important;\n}\n\n/* Forçar cores ICAVI em elementos option quando em focus - TEXTO LARANJA */\nselect option:focus {\n  background: #ffe4d6 !important;\n  background-color: #ffe4d6 !important;\n  background-image: none !important;\n  color: var(--color-icavi-600) !important;\n}\n\n/* Forçar cores ICAVI em elementos option quando ativos - TEXTO LARANJA */\nselect option:active {\n  background: #ffe4d6 !important;\n  background-color: #ffe4d6 !important;\n  background-image: none !important;\n  color: var(--color-icavi-600) !important;\n}\n\n/* Forçar cores ICAVI em inputs quando em foco.\n   `data-foco-proprio`: o componente desenha o próprio foco (ex.: composer do ICAVI AI, foco na caixa inteira). */\ninput:focus:not([data-foco-proprio]) {\n  border-color: var(--color-icavi-600) !important;\n  box-shadow: 0 0 0 1px var(--color-icavi-600) !important;\n  outline: none !important;\n}\n\n/* Forçar cores ICAVI em textareas quando em foco */\ntextarea:focus:not([data-foco-proprio]) {\n  border-color: var(--color-icavi-600) !important;\n  box-shadow: 0 0 0 1px var(--color-icavi-600) !important;\n  outline: none !important;\n}\n\n/* Override para elementos com classes Tailwind específicas */\n.focus\\:ring-icavi-orange:focus {\n  --tw-ring-color: var(--color-icavi-600) !important;\n  box-shadow: 0 0 0 1px var(--color-icavi-600) !important;\n}\n\n.focus\\:border-icavi-orange:focus {\n  border-color: var(--color-icavi-600) !important;\n}\n\n/* Forçar cores ICAVI em elementos com ring */\n[class*='focus:ring-icavi']:focus {\n  box-shadow: 0 0 0 1px var(--color-icavi-600) !important;\n}\n\n/* Forçar cores ICAVI em elementos com border */\n[class*='focus:border-icavi']:focus {\n  border-color: var(--color-icavi-600) !important;\n}\n\n/* Override específico para elementos select com classes Tailwind */\nselect.focus\\:ring-icavi-orange:focus,\nselect.focus\\:border-icavi-orange:focus {\n  border-color: var(--color-icavi-600) !important;\n  box-shadow: 0 0 0 1px var(--color-icavi-600) !important;\n  outline: none !important;\n}\n\n/* Override para elementos input com classes Tailwind */\ninput.focus\\:ring-icavi-orange:focus,\ninput.focus\\:border-icavi-orange:focus {\n  border-color: var(--color-icavi-600) !important;\n  box-shadow: 0 0 0 1px var(--color-icavi-600) !important;\n  outline: none !important;\n}\n\n/* Override para elementos textarea com classes Tailwind */\ntextarea.focus\\:ring-icavi-orange:focus,\ntextarea.focus\\:border-icavi-orange:focus {\n  border-color: var(--color-icavi-600) !important;\n  box-shadow: 0 0 0 1px var(--color-icavi-600) !important;\n  outline: none !important;\n}\n\n/* Estilos específicos para hover em elementos select */\nselect:hover {\n  border-color: var(--color-icavi-600) !important;\n}\n\n/* Forçar cores ICAVI em todos os estados de option */\nselect option {\n  background: white !important;\n  background-color: white !important;\n  color: black !important;\n}\n\n/* Estados de interação - hover, focus, active - TEXTO LARANJA */\nselect option:hover,\nselect option:focus,\nselect option:active {\n  background: #ffe4d6 !important;\n  background-color: #ffe4d6 !important;\n  background-image: none !important;\n  color: var(--color-icavi-600) !important;\n}\n\n/* Estados selecionados - fundo laranja, texto branco */\nselect option:checked,\nselect option[selected] {\n  background: var(--color-icavi-600) !important;\n  background-color: var(--color-icavi-600) !important;\n  background-image: none !important;\n  color: white !important;\n}\n\n/* Forçar para elementos que têm a propriedade selected */\nselect option[selected='selected'],\nselect option[selected='true'] {\n  background: var(--color-icavi-600) !important;\n  background-color: var(--color-icavi-600) !important;\n  color: white !important;\n}\n\n/* Estilos específicos para navegadores WebKit (Chrome, Safari, Edge) */\nselect option::-webkit-option {\n  background-color: white !important;\n  color: black !important;\n}\n\nselect option:hover::-webkit-option,\nselect option:focus::-webkit-option,\nselect option:active::-webkit-option {\n  background-color: #ffe4d6 !important;\n  color: var(--color-icavi-600) !important;\n}\n\nselect option:checked::-webkit-option,\nselect option[selected]::-webkit-option {\n  background-color: var(--color-icavi-600) !important;\n  color: white !important;\n}\n\n/* Estilos específicos para Firefox */\nselect option:-moz-any() {\n  background-color: white !important;\n  color: black !important;\n}\n\nselect option:hover:-moz-any(),\nselect option:focus:-moz-any(),\nselect option:active:-moz-any() {\n  background-color: #ffe4d6 !important;\n  color: var(--color-icavi-600) !important;\n}\n\nselect option:checked:-moz-any(),\nselect option[selected]:-moz-any() {\n  background-color: var(--color-icavi-600) !important;\n  color: white !important;\n}\n\n/* Remover especificamente cores azuis do Windows */\n@supports (-ms-ime-align: auto) {\n  select option:checked {\n    background: var(--color-icavi-600) !important;\n    background-color: var(--color-icavi-600) !important;\n    background-image: none !important;\n    color: white !important;\n  }\n  select option:hover {\n    background: #ffe4d6 !important;\n    background-color: #ffe4d6 !important;\n    background-image: none !important;\n    color: var(--color-icavi-600) !important;\n  }\n  select option:focus {\n    background: #ffe4d6 !important;\n    background-color: #ffe4d6 !important;\n    background-image: none !important;\n    color: var(--color-icavi-600) !important;\n  }\n  select option:active {\n    background: #ffe4d6 !important;\n    background-color: #ffe4d6 !important;\n    background-image: none !important;\n    color: var(--color-icavi-600) !important;\n  }\n}\n\n/* Remover cores azuis em navegadores modernos */\nselect option::selection {\n  background: var(--color-icavi-600) !important;\n  color: white !important;\n}\n\nselect option::-moz-selection {\n  background: var(--color-icavi-600) !important;\n  color: white !important;\n}\n\n/* Garantir que nenhum azul apareça */\nselect option {\n  accent-color: var(--color-icavi-600) !important;\n}\n\nselect {\n  accent-color: var(--color-icavi-600) !important;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
